const DATE_SEARCH_PATTERN =
  /^(\d{4}-\d{2}-\d{2}|\d{1,2}[/.-]\d{1,2}[/.-]\d{2,4})$/;

const ID_PREFIX_PATTERN = /^(?:id|user|client|uid)\s*[:#]?\s*(\d+)$/i;

function parseSearchDob(value) {
  if (!value) return "";
  const raw = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(raw)) return raw.slice(0, 10);
  const slash = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (slash) {
    const [, day, month, year] = slash;
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }
  const dashed = raw.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
  if (dashed) {
    const [, day, month, year] = dashed;
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }
  const dotted = raw.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
  if (dotted) {
    const [, day, month, year] = dotted;
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  }
  const parsed = new Date(raw);
  if (!Number.isNaN(parsed.getTime())) {
    return parsed.toISOString().slice(0, 10);
  }
  return "";
}

/**
 * Whether the debounced search value should be sent to the API
 * (do not wait for 3 characters for numeric IDs or DOB-shaped input).
 */
export function shouldApplyCommissionsSearchInput(rawInput = "") {
  const term = String(rawInput ?? "").trim();
  if (!term) return true;

  const idMatch = term.match(ID_PREFIX_PATTERN);
  const numericCandidate = idMatch ? idMatch[1] : term;
  if (/^\d+$/.test(numericCandidate)) return true;

  if (DATE_SEARCH_PATTERN.test(term)) return true;

  return term.length >= 3;
}

/**
 * Map toolbar search text to API query fields (plus generic searchTerm when needed).
 */
export function resolveCommissionsSearchParams(rawSearchTerm = "") {
  const term = String(rawSearchTerm ?? "").trim();
  if (!term) {
    return {
      searchTerm: undefined,
      client_id: undefined,
      user_id: undefined,
      dob: undefined,
    };
  }

  const idMatch = term.match(ID_PREFIX_PATTERN);
  if (idMatch) {
    const id = idMatch[1];
    return {
      searchTerm: id,
      client_id: id,
      user_id: id,
      dob: undefined,
    };
  }

  if (/^\d+$/.test(term)) {
    return {
      searchTerm: term,
      client_id: term,
      user_id: term,
      dob: undefined,
    };
  }

  const dob = parseSearchDob(term);
  if (dob && DATE_SEARCH_PATTERN.test(term)) {
    return {
      searchTerm: undefined,
      client_id: undefined,
      user_id: undefined,
      dob,
    };
  }

  return {
    searchTerm: term,
    client_id: undefined,
    user_id: undefined,
    dob: undefined,
  };
}

export function mergeCommissionsClientLookupParams(
  searchParams = {},
  filterClientUserId = "",
  filterClientDob = "",
) {
  const clientId = String(filterClientUserId ?? "").trim();
  const dob = parseSearchDob(filterClientDob);

  return {
    client_id: clientId || searchParams.client_id || undefined,
    user_id: clientId || searchParams.user_id || undefined,
    dob: dob || searchParams.dob || undefined,
    searchTerm: searchParams.searchTerm,
  };
}
